import { HelpCircleIcon } from '@approvalmax/ui';
import { Flex, Grid, Link, Text, Tooltip } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './ConnectToOrganisationContent.messages';
import { ConnectToOrganisationContentProps } from './ConnectToOrganisationContent.types';

export const ConnectToOrganisationContent: FC<ConnectToOrganisationContentProps> = memo((props) => {
    const { systemName } = props;

    return (
        <Grid gap={12}>
            <Flex spacing='8' wrap={false} alignItems='start'>
                <Tooltip activator={<HelpCircleIcon width={16} height={16} />} width={400} placement='top'>
                    {messages.tooltip1}
                </Tooltip>

                <Text font='body' fontSize='small'>
                    {messages.connectToOrgDescribe1({ systemName })}
                </Text>
            </Flex>

            <Flex spacing='8' wrap={false} alignItems='start'>
                <Tooltip activator={<HelpCircleIcon width={16} height={16} />} width={400} safePolygon>
                    {messages.tooltip2({
                        trustCenterLink: (chunks: any) => (
                            <Link font='body' external href='https://security.approvalmax.com'>
                                {chunks}
                            </Link>
                        ),
                    })}
                </Tooltip>

                <Text font='body' fontSize='small'>
                    {messages.connectToOrgDescribe2}
                </Text>
            </Flex>
        </Grid>
    );
});

ConnectToOrganisationContent.displayName = 'ConnectToOrganisationContent';
